export default "__VITE_ASSET__DfP7fNRn__"